'use client';

export { BuyTheLook, type BuyTheLookProps } from './ui/buy-the-look';
